import { isArray } from 'lodash';
import { AnyType } from '@src/models/common';

export const getOptionsMap = (options: AnyType[]) => {
  const map = new Map();
  options?.forEach((o) => {
    map.set(o.value, o);
  });

  return map;
};

export const findCurrValue = (options: AnyType[], desiredVal: AnyType): AnyType => {
  if (desiredVal !== undefined) {
    const optionsMap = getOptionsMap(options);

    return optionsMap.get(desiredVal);
  }

  // undefined в принципе не правильно использовать для сброса значения инпутов
  // пустой объект начинает мешать отображению плавающего плейсхолдера
  return null;
};

export const findCurrValueList = (options: AnyType[], desiredVal: AnyType[]): AnyType[] => {
  const ret = [] as AnyType[];
  if (desiredVal && isArray(desiredVal)) {
    const optionsMap = getOptionsMap(options);

    for (const value of desiredVal) {
      const fullValue = optionsMap.get(value);

      if (fullValue) {
        ret.push(fullValue);
      }
    }
  }
  return ret;
};
